export enum DeploymentStatus {
    LIVE = "live",
    LOADING = "loading",
    DOWN = "down",
}
